import {BulkTranslation} from 'bulk-workflows/translation/BulkTranslationConstants';
import * as BulkTranslationUtil from 'bulk-workflows/translation/BulkTranslationUtil';
import {EventConstants} from 'constants/EventConstants';
import AppDispatcher, {FluxAction} from 'lib/Dispatcher';
import Store from 'lib/Store';

class BulkTranslationStore extends Store {
  bulkTranslation!: BulkTranslation;

  override resetState(): void {
    // Supports one bulk translation at a time
    this.bulkTranslation = BulkTranslationUtil.createBulkTranslation();
  }

  getBulkTranslation(): BulkTranslation {
    return this.bulkTranslation;
  }

  override payloadHandler(action: FluxAction): boolean {
    switch (action.actionType) {
      case EventConstants.BULK_TRANSLATE_UPDATE: {
        this.bulkTranslation = BulkTranslationUtil.Update.update(this.bulkTranslation, action.updates);
        this.emitChange();
        break;
      }
      case EventConstants.BULK_TRANSLATE_UPDATE_TRANSLATION_SPEC: {
        this.bulkTranslation = BulkTranslationUtil.Update.updateTranslationSpec(
          this.bulkTranslation,
          action.translationSpecIndex,
          action.updates
        );
        this.emitChange();
        break;
      }
      case EventConstants.BULK_TRANSLATE_RUN_COMPLETED: {
        this.bulkTranslation = BulkTranslationUtil.Update.update(this.bulkTranslation, {errors: []});
        this.emitChange();
        break;
      }
      default:
        break;
    }
    return true;
  }
}

const bulkTranslationStore = new BulkTranslationStore(AppDispatcher);
export default bulkTranslationStore;
